import { useAccountTypeNavigation } from "../../../hooks/useAccountTypeNavigation";
import {
  INCOMES_BREADCRUMB,
  INCOMES_PATH,
  INCOMES_STRUCTURE_CRUMBS,
} from "./incomes.constants";

export function useIncomesNavigation() {
  return useAccountTypeNavigation({
    path: INCOMES_PATH,
    listBreadcrumb: INCOMES_BREADCRUMB.list,
    structureCrumbs: INCOMES_STRUCTURE_CRUMBS,
  });
}
